module.exports = __webpack_public_path__ + "static/media/person6.782583f3.jpeg";